import { useMemo } from "react";
import { Typography } from "@mui/material";
import DOMPurify from "dompurify";
import { DragAndDropAnswer, DragAndDropOptionInstructor } from "@verity/api-client/types";
import pageStyles from "../QuizResultPanel.module.css";
import styles from "./QuestionAnswer.module.css";
import { AnswerStatusChip, AnswerViewProps, CorrectAnswerViewProps, parseBlankSegments, t } from "./shared";

export function DragAndDropAnswerView({ question, response }: AnswerViewProps) {
	const options = (question.options as DragAndDropOptionInstructor[] | undefined) ?? [];
	const userAnswers: DragAndDropAnswer = (response?.answer as DragAndDropAnswer) ?? {};
	const segments = useMemo(() => parseBlankSegments(question.questionText), [question.questionText]);
	const isAnswered = response?.isAnswered === true;

	return (
		<div className={styles.blankCard}>
			<div className={styles.blankInlineWrapper}>
				{segments.map((seg, i) => {
					if (seg.type === "html") {
						return <span key={i} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(seg.content) }} />;
					}
					const correctOption = options.find((o) => o.blankId === seg.blankId && (o.weightage ?? 0) > 0);
					const userText = (userAnswers[seg.blankId] ?? "").trim();
					const isCorrect = !userText ? null : isAnswered && correctOption?.text === userText;
					return <AnswerStatusChip key={i} userText={userText} isCorrect={isCorrect} />;
				})}
			</div>
		</div>
	);
}

export function DragAndDropCorrectAnswer({ question }: CorrectAnswerViewProps) {
	const options = (question.options as DragAndDropOptionInstructor[] | undefined) ?? [];
	const correct = options.filter((o) => o.blankId !== undefined && (o.weightage ?? 0) > 0);
	if (correct.length === 0) return null;
	const sorted = [...correct].sort((a, b) => (a.blankId ?? 0) - (b.blankId ?? 0));
	return (
		<div className={styles.correctAnswerSection}>
			<Typography className={pageStyles.sectionLabel}>{t("correctAnswer")}</Typography>
			<div className={styles.correctAnswerList}>
				{sorted.map((opt, i) => (
					<Typography key={opt.blankId} className={styles.correctAnswerItem}>
						<span className={styles.correctAnswerLabel}>{t("blankLabel", { n: i + 1 })}</span> {opt.text}
					</Typography>
				))}
			</div>
		</div>
	);
}
